import React from 'react';

import { AnimatePresence } from 'framer-motion';

import { Sheet } from '@pkg/components';
import { useAppSelector } from '@pkg/hooks';
import { useMediaQuery } from '@pkg/providers';

import { useManagerFilterProps } from '@app/pages/Prototype/NftManagerPanel/hooks';

import { FiltersListToggle } from '../../../FiltersListToggle';
import { FiltersListToggleWrapper } from '../../styles';
import { PanelHeader } from '../PanelHeader';
import { SortDropdown } from '../SortDropdown';

import { SelectedFiltersList } from './components';

type FilterHeaderProps = {
    onToggle: () => void;
    totalResults: number;
    showSidebar: boolean;
};

export function FilterHeader({ totalResults, onToggle, showSidebar }: FilterHeaderProps) {
    const { tablet } = useMediaQuery();
    const { filtersCount } = useManagerFilterProps();
    const managerSearchValue = useAppSelector((state) => state.nftManager.managerSearchValue);

    if (tablet) {
        return (
            <Sheet.Layout.Section padded>
                <PanelHeader total={totalResults} isSearch={!!managerSearchValue} />

                {managerSearchValue ? null : (
                    <Sheet.Layout.Columns stretch>
                        <Sheet.Layout.Columns.Primary>
                            <SortDropdown />
                            <SelectedFiltersList />
                        </Sheet.Layout.Columns.Primary>

                        <AnimatePresence initial={false}>
                            <Sheet.Layout.Columns.Secondary>
                                <FiltersListToggleWrapper>
                                    <FiltersListToggle count={filtersCount} open={showSidebar} onToggle={onToggle} />
                                </FiltersListToggleWrapper>
                            </Sheet.Layout.Columns.Secondary>
                        </AnimatePresence>
                    </Sheet.Layout.Columns>
                )}
            </Sheet.Layout.Section>
        );
    }

    return (
        <Sheet.Layout.Section padded>
            <PanelHeader total={totalResults} />
        </Sheet.Layout.Section>
    );
}
